<div class="section">
  <div class="row">
    <div
      class="col-sm"
      *ngIf="
        (data.messageType != 'duplicateVeeva' &&
          data.messageType != 'deleteRow' &&
          data.messageType != 'ConfirmPopup' &&
          data.messageType != 'editClaimsWarning' &&
          data.messageType != 'errorCheck' &&
          data.messageType != 'msgNotify' &&
          data.messageType != 'clearProduct' &&
          data.messageType != 'ira-alert' &&
          data.messageType != 'longWait' &&
          data.messageType === 'iraPopup') ||
        data.messageType == 'editClaims' ||
        data.messageType === 'noDataSelect'
      "
    >
      <div class="close-header">
        <img
          src="/assets/images/icons/alert-close.svg"
          class="close-icon"
          alt="close-icon"
          (click)="oncancelClick()"
        />
      </div>
    </div>
  </div>

  <div class="center-screen" *ngIf="data.messageType == 'fileUpload'">
    <div class="row">
      <div class="col-sm">
        <div class="text-title-support">
          <span>
            {{ data.message }}
          </span>
        </div>
      </div>
    </div>
  </div>

  <div class="row" *ngIf="data.messageType == 'editClaimsWarning'">
    <div class="col-sm">
      <div class="text-title-msg">
        <span>
          Copying data to other geography is not possible as the table data
          contains language other than the language present in project's
          geography
          <br />
          <br />
          Please deselect the claims that are in a different language from the
          geography you are looking to generate local adaptations for.</span
        >
      </div>
    </div>
  </div>

  <div
    class="center-screen"
    *ngIf="data.messageType !== 'deleteRow'"
    style="display: none"
  >
    <div class="row">
      <div class="col-sm">
        <div class="text-title-support">
          <span>
            Kindly confirm the changes before the processing <br />
            to Support & Substantiation?
          </span>
        </div>
      </div>
    </div>
  </div>

  <!-- <div class="center-screen" *ngIf="data.messageType === 'duplicateVeeva'">
    <div class="row">
      <div class="col-sm">
        <div class="duplicate-msg-sec">
          <span>{{ data.headerText }} </span>
        </div>
        <div class="text-title-message">
          <span [innerHTML]="data.message"> </span>
        </div>
        <div
          class="text-title-message"
          *ngFor="let line of data.messageLines"
          [ngClass]="{ 'spacer-line': line === '' }"
        >
          <span *ngIf="line !== ''" [innerHTML]="line"></span>
        </div>

        <div class="text-title-new-row">
          <span>{{ data.lowerText }} </span>
        </div>
      </div>
    </div>
  </div> -->

  <div class="center-screen" *ngIf="data.messageType === 'duplicateVeeva'">
    <div class="row">
      <div class="col-sm">
        <div class="duplicate-msg-sec">
          <span>{{ data.headerText }} </span>
        </div>
        <div class="text-title-message" *ngIf="data.message">
          <span [innerHTML]="data.message"> </span>
        </div>
        <div *ngIf="data.messageLines">
          <div
            class="text-title-message"
            *ngFor="let line of data.messageLines"
            [ngClass]="{ 'spacer-line': line === '' }"
          >
            <span *ngIf="line !== ''" [innerHTML]="line"></span>
          </div>
        </div>
        <div class="text-title-new-row">
          <span>{{ data.lowerText }} </span>
        </div>
      </div>
    </div>
  </div>

  <div
    class="center-screen"
    *ngIf="
      data.messageType === 'iraPopup' || data.messageType === 'noDataSelect'
    "
  >
    <div class="row">
      <div class="col-sm">
        <div class="text-title-ira">
          <span> {{ data.msg }} </span>
        </div>
      </div>
    </div>
  </div>

  <div class="center-screen" *ngIf="data.messageType === 'deleteRow'">
    <div class="row">
      <div class="col-sm">
        <div class="text-title-delete">
          <span> Are you sure you want to delete the row ? </span>
        </div>
      </div>
    </div>
  </div>

  <div class="center-screen" *ngIf="data.messageType === 'ira-alert'">
    <div class="row">
      <div class="col-sm">
        <div class="text-title-delete">
          <span> {{ data.message }} </span>
        </div>
      </div>
    </div>
  </div>

  <div class="center-screen" *ngIf="data.messageType === 'errorCheck'">
    <div class="row">
      <div class="col-sm">
        <div class="text-title-delete">
          <span> {{ data.message }} </span>
        </div>
      </div>
    </div>
  </div>

  <div
    class="center-screen"
    *ngIf="data.messageType === 'msgNotify' || data.messageType === 'longWait'"
  >
    <div class="row">
      <div class="col-sm">
        <div class="text-title-delete">
          <span> {{ data.message }} </span>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="data.messageType === 'editClaims'">
    <div class="row">
      <div class="col-sm">
        <div class="text-title">
          <span>
            Please select a geography you wish to generate the local adaptations
          </span>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="data.messageType === 'clearProduct'">
    <div class="row">
      <div class="col-sm">
        <div class="text-title-delete">
          <span>
            <!-- Any changes to product will reload the page. All unsaved -->
            {{ data.messages }}
            <span style="display: flex; justify-content: center">
              <!-- changes will be lost. Do you wish to proceed? -->
              {{ data.messagessub }}</span
            >
          </span>
        </div>
      </div>
    </div>
  </div>

  <div class="editClaims-sec" *ngIf="data.messageType === 'editClaims'">
    <div class="row">
      <div class="col-sm">
        <div class="form-group">
          <label class="asset-type-label">
            Geography
            <span class="label-icon">*</span>
          </label>
        </div>
        <div class="form-group">
          <p-dropdown
            [options]="geographyData"
            [(ngModel)]="selectedGeography"
            optionLabel="country_name"
            optionValue="country__v"
            placeholder="Select Geography"
            (onChange)="geographyvaluechange($event)"
            class="geography-dropdown"
          ></p-dropdown>
        </div>
      </div>
    </div>
  </div>

  <div
    class="page-container"
    *ngIf="
      data.messageType === 'deleteRow' ||
      data.messageType === 'editClaims' ||
      data.messageType === 'msgNotify' ||
      data.messageType === 'clearProduct' ||
      data.messageType === 'iraPopup' ||
      data.messageType === 'longWait' ||
      data.messageType === 'noDataSelect'
    "
  >
    <div class="button-container">
      <button
        mat-stroked-button
        class="btn-text-cancel"
        (click)="oncancelClick()"
      >
        @if(data.messageType === 'noDataSelect') {Ok} @else if(data.messageType
        === 'longWait'){ Wait } @else {Cancel}
      </button>
      @if(data.messageType !== 'noDataSelect'){ @if(data.messageType ===
      'editClaims'){
      <button
        mat-stroked-button
        class="btn-text-proceed"
        (click)="onConfirmClick()"
        [disabled]="selectedGeography.length == 0"
        [ngClass]="{ 'common-disabled-colour': selectedGeography.length == 0 }"
      >
        Confirm
      </button>
      } @else{
      <button mat-stroked-button class="btn-text-proceed" (click)="onConfirm()">
        @if(data.messageType === 'longWait'){ New Search }@else{ Confirm }
      </button>
      } }
    </div>
  </div>

  <div
    class="ok-button-container"
    *ngIf="
      data.messageType === 'fileUpload' ||
      data.messageType === 'editClaimsWarning' ||
      data.messageType === 'errorCheck' ||
      data.messageType === 'ira-alert'
    "
  >
    <button
      mat-stroked-button
      class="btn-text-proceed"
      (click)="oncancelClick()"
    >
      Ok
    </button>
  </div>

  <div
    class="ok-button-container duplicate-veeva-btn"
    *ngIf="
      data.messageType === 'duplicateVeeva'">
    <button
      mat-stroked-button
      class="btn-text-proceed"
      (click)="oncancelClick()"
    >
      Ok
    </button>
  </div>
  <div *ngIf="data.messageType === 'ConfirmPopup'" class="popup">
    <h2>Your Claims Are Getting Saved</h2>
    <p>We will notify you once this operation is completed</p>
    <div class="popup-buttons">
      <button class="bulk-btn" (click)="navigate('bulk')">Bulk Add</button
      ><button class="edit-btn" (click)="navigate('edit')">
        Edit Claims/LAs
      </button>
      <button class="project-btn" (click)="navigate('project')">Project</button
      ><button class="continue-btn" (click)="navigate('continue')">
        Continue Here
      </button>
    </div>
  </div>
</div>
